import * as React from 'react'

const ChevronDown = props => (
  <svg width="24" height="8" viewBox="0 0 24 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2L12 6L2 2" stroke="#3C52EF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default ChevronDown
